"use strict";

/* A service / model */

_BannerFlowApp.factory(
    "EventManager",
    function ($rootScope, Global, $timeout, $state, Page, $location, ngDialog) {
        return {
            SetupEventHandlers: function () {
                $rootScope.$on("event:auth-loginRequired", function () {
                    window.location = "/";
                });

                $rootScope.$on("event:auth-noPermission", function () {
                    $rootScope.showNoPermissionDialog = true;
                });

                $rootScope.$on("event:auth-nopayment", function () {
                    $state.go("root.buybannerflow");
                });

                $rootScope.$on("event:general-error", function (error, bannerFlowRequestId) {
                    //Blur the background when initialized
                    $("body").addClass("blur");

                    var dialog = ngDialog.open({
                        className: "error-dialog bf-ui",
                        controller: "ErrorDialogController",
                        template: "/legacy-app/views/Error/error-dialog.html",
                        data: { data: bannerFlowRequestId },
                        appendTo: "body"
                    });

                    dialog.closePromise.then(function (response) {
                        $("body").removeClass("blur");
                    });
                });

                $rootScope.$on("event:error-notfound", function () {
                    window.location = "/OopsNotFound";
                });

                var locationSearch = {};

                $rootScope.$on(
                    "$stateChangeStart",
                    function (event, toState, toParams, fromState, fromParams) {
                        locationSearch = angular.copy($location.search());
                        $rootScope.modalOpen = false;
                        if (fromState.name === "root.feeds.feed") {
                            if ($rootScope.feedIsDirty) {
                                if (
                                    confirm(
                                        "You have unsaved changes. If you leave this page your changes will be lost."
                                    )
                                ) {
                                    return true;
                                } else {
                                    event.preventDefault();
                                    return false;
                                }
                            }
                        }
                    }
                );

                $rootScope.$on(
                    "$stateChangeSuccess",
                    function (event, _toState, toParams, fromState, fromParams) {
                        //Reset timezone preference
                        moment.tz.setDefault("");

                        var isRootParent = false;

                        $rootScope._previousState = fromState;

                        Page.SetPrevious(
                            $state.$current.parent.self.title,
                            $state.$current.parent.self.name,
                            null,
                            isRootParent,
                            locationSearch
                        );
                        $(window).scrollTop(0);
                    }
                );

                $rootScope.$on("putWasSuccessfull", function () {
                    $timeout(function () {
                        Global.Loading(false);
                    }, 250);
                });

                $rootScope.$on("putFailed", function () {
                    Global.Loading(false);
                });

                $rootScope.$on("putWasInitiated", function () {
                    Global.Loading(true);
                });
            }
        };
    }
);
